import { __awaiter } from 'tslib';
import 'long';
import '../proto/index.js';
import '../core/consts.js';
import { Logger } from '../core/metrics/logger.js';
import '../core/metrics/monitor.js';
import { ServiceIdentity } from '../core/service/RuntimeContext.js';
import '../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import { BasePlugin } from '../core/plugin/BasePlugin.js';
import '../core/model/CommandMessage.js';

class SharkPlugin extends BasePlugin {
    constructor() {
        super(...arguments);
        this.enabled = true;
    }
    install() {
        this.register(ServiceIdentity.SharkPlugin, this);
        try {
            if (this.ctx.option.sharkAppName === undefined || this.ctx.option.sharkPriorityRegion === undefined) {
                Logger.ctxWarn(this.ctx, 'shark required field not provided, ignore shark params');
                this.enabled = false;
            }
            if (typeof navigator === 'undefined') {
                Logger.ctxWarn(this.ctx, 'window.navigator not available, may missing param');
            }
            if (typeof screen === 'undefined') {
                Logger.ctxWarn(this.ctx, 'window.screen not available, may missing param');
            }
            if (typeof document === 'undefined') {
                Logger.ctxWarn(this.ctx, 'window.document not available, may missing param');
            }
            if (typeof Intl === 'undefined'
                || !(typeof Intl !== 'undefined'
                    && typeof Intl.DateTimeFormat === 'function'
                    && typeof Intl.DateTimeFormat().resolvedOptions === 'function')) {
                Logger.ctxWarn(this.ctx, 'window.Intl not available, may missing param');
            }
        }
        catch (err) {
            Logger.ctxError(this.ctx, 'shark init error:', err);
            this.enabled = false;
        }
    }
    sendPacket(req) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.enabled) {
                this.fillSharkParam(req);
            }
            return req;
        });
    }
    fillSharkParam(req) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const params = {};
        try {
            // biz
            params.session_aid = (_a = this.ctx.option.appId.toString()) !== null && _a !== void 0 ? _a : '';
            params.session_did = (_b = this.ctx.option.deviceId.toString()) !== null && _b !== void 0 ? _b : '';
            params.app_name = this.ctx.option.sharkAppName;
            params.priority_region = this.ctx.option.sharkPriorityRegion;
            // navigator
            if (typeof navigator !== 'undefined') {
                params.user_agent = (_c = navigator.userAgent) !== null && _c !== void 0 ? _c : '';
                params.cookie_enabled = (_e = (_d = navigator.cookieEnabled) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '';
                params.browser_language = (_f = navigator.language) !== null && _f !== void 0 ? _f : '';
                params.browser_platform = (_g = navigator.platform) !== null && _g !== void 0 ? _g : '';
                params.browser_name = (_h = navigator.appCodeName) !== null && _h !== void 0 ? _h : '';
                params.browser_version = (_j = navigator.appVersion) !== null && _j !== void 0 ? _j : '';
                params.browser_online = (_l = (_k = navigator.onLine) === null || _k === void 0 ? void 0 : _k.toString()) !== null && _l !== void 0 ? _l : '';
            }
            // screen
            if (typeof screen !== 'undefined') {
                params.screen_width = (_o = (_m = screen.width) === null || _m === void 0 ? void 0 : _m.toString()) !== null && _o !== void 0 ? _o : '';
                params.screen_height = (_q = (_p = screen.height) === null || _p === void 0 ? void 0 : _p.toString()) !== null && _q !== void 0 ? _q : '';
            }
            // document
            if (typeof document !== 'undefined') {
                params.referer = (_r = document.referrer) !== null && _r !== void 0 ? _r : '';
            }
            // intl
            if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function' && typeof Intl.DateTimeFormat().resolvedOptions === 'function') {
                params.timezone_name = (_s = Intl.DateTimeFormat().resolvedOptions().timeZone) !== null && _s !== void 0 ? _s : '';
            }
        }
        catch (err) {
            Logger.ctxWarn(this.ctx, 'load shark param error, may missing param', err);
        }
        req.headers = Object.assign(Object.assign({}, req.headers), params);
    }
}

export { SharkPlugin };
//# sourceMappingURL=SharkPlugin.js.map
